export const radioRule = {
  rules: [{ required: true, message: 'กรุณาเลือก!' }]
}

export const inputRule = {
  rules: [{ required: true, message: 'กรุณากรอก!' }]
}

export const passwordRule = {
  rules: [{ required: true, message: 'กรุณากรอกรหัสผ่าน!' }]
}

export const dateRule = {
  rules: [{ required: true, message: 'กรุณาเลือกวันที่!' }]
}

export const selectRule = {
  rules: [{ required: true, message: 'กรุณาเลือก!' }]
}

export const timeRule = {
  rules: [{ required: true, message: 'กรุณาเลือกเวลา!' }]
}



// WEBPACK FOOTER //
// ./src/utils/rules.js